import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import {
  AddEstimateLineItemInput,
  AddEstimateLineItemMutation as AddEstimateLineItemMutationResult,
} from '@/gql/graphql';
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { hydrateEstimateCaches } from './hydrateEstimateCaches';

const AddEstimateLineItemMutation = graphql(`
  mutation AddEstimateLineItem($input: AddEstimateLineItemInput!) {
    addEstimateLineItem(input: $input) {
      ...EstimateBuilderEstimate
      preview {
        template
        context
        pendingSolarLayoutImage
      }
    }
  }
`);

const useAddEstimateLineItem = <
  TVariables extends AddEstimateLineItemInput = AddEstimateLineItemInput,
>(args: {
  projectId: string;
  estimateId: string;
  options?: UseMutationOptions<
    AddEstimateLineItemMutationResult,
    Error,
    TVariables
  >;
}) => {
  const { projectId, estimateId } = args;
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = args.options ?? {};

  return useMutation<AddEstimateLineItemMutationResult, Error, TVariables>({
    mutationFn: ({ sectionId, lineItemId, quantity, taxRateId }) => {
      return gqlClient.request(AddEstimateLineItemMutation, {
        input: { sectionId, lineItemId, quantity, taxRateId },
      });
    },
    onSuccess: (data, variables, context) => {
      hydrateEstimateCaches(queryClient, {
        projectId,
        estimateId,
        estimate: data.addEstimateLineItem,
      });
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useAddEstimateLineItem;
